import { render } from "./OrderCreateEnergy.vue?vue&type=template&id=3856f314"
import script from "./OrderCreateEnergy.vue?vue&type=script&lang=js"
export * from "./OrderCreateEnergy.vue?vue&type=script&lang=js"

import "./OrderCreateEnergy.vue?vue&type=style&index=0&id=3856f314&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__